module.exports = __webpack_public_path__ + "static/media/xray1.19f5c306.png";